import React from 'react'
import './steps.css'

const Steps = ({ Step = 0 }) => {

    return (

        <section className="steps">

            <div className={`step ${Step >= 1 ? 'active' : ''}`}>
                <span>1</span>
                <p>Serviço</p>
            </div>
            <div className={`line ${Step >= 2 ? 'active' : ''}`}></div>
            <div className={`step ${Step >= 2 ? 'active' : ''}`}>
                <span>2</span>
                <p>Profissional</p>
            </div>
            <div className={`line ${Step >= 3 ? 'active' : ''}`}></div>
            <div className={`step ${Step >= 3 ? 'active' : ''}`}>
                <span>3</span>
                <p>Data/Horário</p>
            </div>
            <div className={`line ${Step >= 4 ? 'active' : ''}`}></div>
            <div className={`step ${Step >= 4 ? 'active' : ''}`}>
                <span>4</span>
                <p>Confirmação</p>
            </div>
        </section >

    )
}

export default Steps